import styled from 'styled-components';

export const NewWindowLink = styled.a`
`;
